import { types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";

const prefixUrl = "/client/record";

export default {
    async list(param: types.ReqParam): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/list", param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async detail(idx: number): Promise<types.client.ResClientForRecord> {
        const res = {} as types.client.ResClientForRecord;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/detail/" + idx, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async modify(idx: number, targetIdx: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/modify/" + idx + "/" + targetIdx, null, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },
};
